import React from 'react';
import { BodyText, Column, Row } from '@chargify/custom-ui-components';

export type DetailsRowProps = {
  label: string;
  value: string;
};
const DetailRow = ({ label, value }: DetailsRowProps) => {
  if (!value) return null;
  return (
    <Column span={24}>
      <Row>
        <Column span={[24, 9]}>
          <div data-testid="detail-label">
            <BodyText variant="body2" color={'gray.dark'} fontWeight={2}>
              {label}
            </BodyText>
          </div>
        </Column>
        <Column span={[24, 15]}>
          <BodyText variant="body2" color={'black.main'} overflow="break-word">
            {value}
          </BodyText>
        </Column>
      </Row>
    </Column>
  );
};
export default DetailRow;
